import Webinars from './BiosecurityWebSeries/Webinars';
const Webinar = ({ sectionTitle, ...props }) => {
    return (
        <div className='webinar-series'>
            <h1 className='series-title' > {sectionTitle} </h1>
            <div className='series-content'>
                <Webinars {...props} />
            </div>
        </div>
    )

}

export default Webinar;